import Image from "next/image";
import clsx from "clsx";

import {
  Icon,
  ICON_SIZES,
  ICON_TYPE,
  type IconNameExtended,
} from "@/components/library/Icon";

export type IntegrationIconFallback = {
  icon: IconNameExtended;
  type: ICON_TYPE;
};

type IntegrationLogosProps = {
  logos: string[];
  /** Featured cards sit on gail-primary — logos need a light treatment. */
  featured?: boolean;
  icon?: IntegrationIconFallback | null;
};

export function IntegrationLogos({
  logos,
  featured = false,
  icon,
}: Readonly<IntegrationLogosProps>) {
  if (logos.length === 0 && icon) {
    return (
      <div
        className={clsx(
          "mb-4 flex h-8 items-center",
          featured && "rounded-lg bg-white/10 px-3 py-2",
        )}
      >
        <Icon
          icon={icon.icon}
          type={icon.type}
          size={ICON_SIZES.XXL}
          className={featured ? "text-white" : "text-gail-primary"}
        />
      </div>
    );
  }

  if (logos.length === 0) {
    return null;
  }

  return (
    <div
      className={clsx(
        "mb-4 flex items-center",
        logos.length > 1 ? "gap-3" : "",
      )}
    >
      {logos.map((src) => (
        <div
          key={src}
          className={clsx(
            "flex items-center",
            featured ? "rounded-lg bg-white/10 px-3 py-2" : "h-8",
          )}
        >
          <Image
            src={src}
            alt=""
            width={featured ? 100 : 120}
            height={32}
            className={clsx(
              "h-6 w-auto max-w-[120px] object-contain object-left",
              featured && "brightness-0 invert",
              logos.length > 1 && !featured && "max-w-[72px]",
            )}
          />
        </div>
      ))}
    </div>
  );
}
